'use strict';

var $ = require('jquery'),
	animating = false,
	mobileNavigation = $('.header .mobile-navigation'),
	mobileNavButton = $('.header .toggleMainNav'),
	searchElement = $('.header .search'),
	searchField = searchElement.find('.search-term'),
	searchToggleButton = $('.nav-text.search-toggle');

// Mobile Navigation
mobileNavButton.click(function(){
	if (mobileNavigation.length && !animating) {
		animating = true;

		if ($(this).hasClass('is-active')) {
			mobileNavigation.slideUp(300, function() {
				animating = false;
			});
			$(this).removeClass('is-active');
		} else {
			mobileNavigation.slideDown(300, function() {
				animating = false;
			});
			
			$(this).addClass('is-active');
		}
	}
});

// Search
searchToggleButton.click(function() {
	if (searchElement.length && !animating) {
		animating = true;

		if (searchElement.hasClass('opened')) {
			searchElement.slideUp(300, function() {
				animating = false;
			}).removeClass('opened');
			$(this).removeClass('opened');
		} else {
			searchElement.slideDown(300, function() {
				animating = false;
			}).addClass('opened');

			searchField.focus();
			searchField.select();
			$(this).addClass('opened');	
		}
	}
});
